import {StyleteqState} from "../_definitions/styleteq";

export const inboxSelector = (state: StyleteqState) => state.conversations;
export const messagesSelector = (state: StyleteqState) => state.messages;


// WEBPACK FOOTER //
// ./app/client/message/selectors.ts